/** PROTOTYPE. Small formatters shared by the model builders. */
import { formatTimestamp } from "../DiagnosticsPanelPrimitives";
import type { StatusTone } from "../DiagnosticsSettings.types";

export { formatTimestamp };

export function state(value: string | null | undefined): string {
  return value?.replaceAll("_", " ") ?? "not reported";
}

export function shortId(value: string | null | undefined): string {
  return value ? value.slice(0, 8) : "not reported";
}

export function toneForState(
  value: string | null | undefined,
  good: ReadonlyArray<string>,
): StatusTone {
  if (!value) return "muted";
  return good.includes(value) ? "ready" : "warning";
}
